import React from "react";
import { useTranslation } from "react-i18next";
import "../../styles/ProfilesManager.css";

export function isValidHttpUrl(value) {
  if (!value || !value.trim()) return false;
  try {
    const url = new URL(value.trim());
    return url.protocol === "http:" || url.protocol === "https:";
  } catch {
    return false;
  }
}

export function isValidIPv4(value) {
  if (!value || !value.trim()) return false;
  const trimmed = value.trim();
  // Allow optional port: 192.168.0.1 or 192.168.0.1:8000
  const match = trimmed.match(
    /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})(?::(\d{1,5}))?$/
  );
  if (!match) return false;

  const [, a, b, c, d, port] = match;
  const octets = [a, b, c, d].map(Number);
  if (octets.some((o) => o < 0 || o > 255)) return false;

  if (port !== undefined) {
    const p = Number(port);
    if (!(p > 0 && p <= 65535)) return false;
  }

  return true;
}

export function isValidTargetUrl(value) {
  return isValidHttpUrl(value) || isValidIPv4(value);
}

export default function UrlInput({
  value,
  onChange,
  placeholder,
  maxLength = 500,
}) {
  const { t } = useTranslation("targets");
  const resolvedPlaceholder = placeholder ?? t("form.urlPlaceholder");
  const length = value?.length || 0;

  return (
    <label className="pm-input-label">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "8px",
        }}
      >
        <span>URL</span>
        <div
          style={{
            fontSize: "12px",
            color: length > maxLength ? "#ef4444" : "#9ca3af",
          }}
        >
          {length} / {maxLength}
        </div>
      </div>
      <input
        className="pm-input"
        type="text"
        value={value || ""}
        onChange={onChange}
        placeholder={resolvedPlaceholder}
        maxLength={maxLength}
      />
    </label>
  );
}
